import React, { useCallback, useEffect, useState } from 'react';

import {
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  Modal,
  TextField,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import _ from 'lodash';
import stylesMaterial from './stylesMaterial';
import { Container, Header, OrderItem } from './styles';
import { useToast } from '../../../../../hooks/toast';
import { IOrderItem } from '../../../../../interfaces/IOrderItem';
import { IPaymentMethod } from '../../../../../interfaces/IPaymentMethod';
import { IDeliveryAddress } from '../../../../../interfaces/IDeliveryAddress';
import { IOrder } from '../../../../../interfaces/IOrder';
import empresaApi, { IEmpresa } from '../../../../../services/empresaApi';
import OrdersService from '../../../../../services/OrdersService';
import { useAuth } from '../../../../../hooks/auth';
import { CgTrashEmpty } from 'react-icons/cg';

interface EditFractionedItemsModalProps {
  open: boolean;
  handleClose: () => void;
  loadPedidoData: () => {};
  order:
    | (Partial<IOrder> & {
        deliveryAddress?: Partial<IDeliveryAddress>;
        orderPayment: Partial<IPaymentMethod> & { companyPaymentMethod?: any }; // alterar
        items: Partial<IOrderItem>[];
      });
}

export function EditFractionedItemsModal({
  open,
  handleClose,
  loadPedidoData,
  order,
}: EditFractionedItemsModalProps) {
  const { caixa, user } = useAuth();
  const classes = stylesMaterial();

  const { addToast } = useToast();

  const [isEditLoading, setIsEditLoading] = useState(false);
  const [fractionedProducts, setFractionedProducts] = useState<IOrderItem[]>(
    [],
  );

  useEffect(() => {
    const filteredItems = order.items.filter((item) => !!item.portioned);
    setFractionedProducts(filteredItems || []);
  }, []);

  const handleEditItems = useCallback(() => {
    setIsEditLoading(true);
    OrdersService.editOrderItems({
      orderId: order.id,
      cashierId: caixa.id,
      companyId: user.empresa_id,
      orderItems: fractionedProducts,
    })
      .then(() => {
        loadPedidoData();
        handleClose();
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro ao atualizar os items',
          // description: error.message,
        });
        setIsEditLoading(false);
      });
  }, [fractionedProducts]);

  const setQuantityToZero = useCallback((prpoductId: number) => {
    const editedFractionedProducts = fractionedProducts.map(product => {
      if (prpoductId === product.id) {
        return { 
          ...product, 
          quantity: 0,
        };
      }

      return product;
    });
    setFractionedProducts(editedFractionedProducts);
  }, [fractionedProducts])

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="insert-in-cart-options-modal"
      aria-describedby="insert-in-cart-options-balance"
      className={classes.modal}
    >
      <Container>
        <Header>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={classes.buttonClose}
          >
            <CloseIcon className={classes.iconClose} />
          </IconButton>
        </Header>

        <FormControl className={classes.formControl}>
          {fractionedProducts.map((item) => (
            <OrderItem key={item.id}>
              <Typography>{item.productName}</Typography>
              <div>
                <TextField
                  label="Quantidade"
                  variant="outlined"
                  type="number"
                  value={item.quantity}
                  onChange={e => {
                    const editedFractionedProducts = fractionedProducts.map(product => {
                      const newValue = Number(Number(e.target.value).toFixed(3));
                      if (item.id === product.id && newValue >= 0) {
                        return { 
                          ...product, 
                          quantity: newValue,
                        };
                      }

                      return product;
                    });
                    setFractionedProducts(editedFractionedProducts);
                  }}
                  className={classes.quantityField}
                />
                <Button 
                  onClick={() => setQuantityToZero(item.id)}
                  className={classes.trashButton}
                >
                  <CgTrashEmpty />
                </Button>
              </div>
            </OrderItem>
          ))}

          <Button
            disabled={isEditLoading}
            onClick={handleEditItems}
            className={classes.button}
          >
            {isEditLoading ? <CircularProgress /> : 'Concluir'}
          </Button>

          <Button
            disabled={isEditLoading}
            onClick={handleClose}
            className={classes.cancelButton}
          >
            Cancelar
          </Button>
        </FormControl>
      </Container>
    </Modal>
  );
}
